import { render, staticRenderFns } from "./crudPricesListsCourses.vue?vue&type=template&id=0ad8f50a&"
import script from "./crudPricesListsCourses.vue?vue&type=script&lang=js&"
export * from "./crudPricesListsCourses.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports